import baseapi from "../baseAPI";

export const StateListAPI = async (setStateList, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/setting/state?page=" + currentPage + "&per_page=" + perpagedata);

        setStateList(response.data.data.data);
        setLoading(false);

        //console.log('Length===' + response.data.data.data.length);
        if(response.data.data.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}


